import ApiService from '../../services/api.service';
import AppService from '../../services/app.service';
import DivisionModel from '../division/division-model';
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerModel from '../owner/owner-model';
import PersonalinfoModel from '../personalinfo/personalinfo-model';
import ScheduleModel from '../schedule/schedule-model';
import TransactiontypeModel from '../transactiontype/transactiontype-model';
import UserModel from '../user/user-model';

export default class TransactionModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;    
    transactiontype: any;
    transactiontypeCaption: string;
    transactiontypePricetype: string;
    transactiondate: any;
    transactiondateFmt: string;
    image: any;
    imageId: number;
    imageUrl: string;    
    employee: any;
    employeeCaption: string;
    customer: any;
    customerCaption: string;
    vendor: any;
    vendorCaption: string;  
    division: any;
    divisionCaption: string;  
    schedule: any;
    scheduleCaption: string;  
    totaldetail: number;
    totalamount: number;
    totalpayment: number;
    total: number;
    totalremaining: number;
    statuspayment: string;
    
    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'draft';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        let transactiontype = datarow.transactiontype?.data? new TransactiontypeModel(datarow.transactiontype?.data) : datarow.transactiontype;
        this.transactiontype = transactiontype?.id;
        this.transactiontypeCaption = transactiontype?.name;
        this.transactiontypePricetype = transactiontype?.pricetype;
        this.transactiondate = datarow.transactiondate;
        this.transactiondateFmt = AppService.dateFormat(datarow.transactiondate, 'y-m-d h:n');
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';
        let employee = datarow.employee?.data? new PersonalinfoModel(datarow.employee?.data) : datarow.employee;
        this.employee = employee?.id;
        this.employeeCaption = employee?.name;
        let customer = datarow.customer?.data? new PersonalinfoModel(datarow.customer?.data) : datarow.customer;
        this.customer = customer?.id;
        this.customerCaption = customer?.name;
        let vendor = datarow.vendor?.data? new PersonalinfoModel(datarow.vendor?.data) : datarow.vendor;
        this.vendor = vendor?.id;
        this.vendorCaption = vendor?.name;
        let division = datarow.division?.data? new DivisionModel(datarow.division?.data) : datarow.division;
        this.division = division?.id;
        this.divisionCaption = division?.name;
        let schedule = datarow.schedule?.data? new ScheduleModel(datarow.schedule?.data) : datarow.schedule;
        this.schedule = schedule?.id;
        this.scheduleCaption = schedule?.name;
        this.totaldetail = datarow.totaldetail;        
        this.totalamount = datarow.totalamount;    
        this.totalpayment = datarow.totalpayment;     
        this.total = datarow.total;
        this.totalremaining = this.total - this.totalpayment;     
        this.statuspayment = datarow.statuspayment || 'unpaid';
    } 

    public static endPoint: string = 'transactions';
    public static endPointMedia: string = 'api::transaction.transaction';
    public static endPointFilterList = (transactiontype?: string, personalinfotypeType?: string, personalinfoId?: number) => {
        const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' + owner + (transactiontype? '&filters[transactiontype][type]=' +transactiontype : '') + (personalinfotypeType && personalinfoId? '&filters[' +personalinfotypeType+ ']=' +personalinfoId : ''));
    } 
    public static endPointFilterList2 = () => {
        const user = UserModel.getUser();
        return ( '?populate=*&sort=name&filters[customer][user]=' + user + '&filters[status]=draft');
    } 
    public static url: string = '/transaction';
    public static caption: string = 'Transaction';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'draft',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),    
        transactiontype: null,
        transactiontypeCaption: '',
        transactiontypePricetype: '',
        transactiondate: AppService.dateCurrent(),
        transactiondateFmt: '',
        image: null,
        imageId: 0,
        imageUrl: '',
        employee: null,
        employeeCaption: '',
        customer: null,
        customerCaption: '',
        vendor: null,
        vendorCaption: '', 
        division: null,
        divisionCaption: '',
        schedule: null,
        scheduleCaption: '', 
        totaldetail: 0,
        totalamount: 0,
        totalpayment: 0,
        total: 0,
        totalremaining: 0,
        statuspayment: 'unpaid',
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
        { name: 'transactiontype', nameAlias: 'Type', required: true },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'customerCaption', caption: 'Customer' },
        { name: 'transactiondateFmt', caption: 'Date' },
        { name: 'statuspayment', caption: 'Status', type: 'state', default: 'paid' },
        { name: 'status', caption: ' ', type: 'state', default: 'approved' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'transactiondate', caption: 'Date', type: 'datetime' },
    ]

    public static columnPicklistCard = [
        { name: 'name', type: 'caption' },
        { name: 'description' },
        { name: 'transactiondate', type: 'datetime' },
        { name: 'status', type: 'state', default: 'approved' },
    ]

    public static optionStatus = [
        { name: 'draft', caption: 'Draft' },
        { name: 'approved', caption: 'Approved' },
        { name: 'rejected', caption: 'Rejected' },
    ]
    
    public static optionStatuspayment = [
        { name: 'paid', caption: 'Paid' },
        { name: 'unpaid', caption: 'Unpaid' },
        { name: 'verification', caption: 'Verification' },
        { name: 'overpayment', caption: 'Overpayment' },
    ]

}